import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArrowUpRight } from "lucide-react";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  if (user) {
    // already logged in
    setTimeout(() => nav("/admin"), 0);
  }

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Signed in");
      nav("/admin");
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-bone flex items-center">
      <div className="grain" aria-hidden/>
      <div className="mx-auto w-full max-w-lg px-6">
        <Link to="/" className="kbd">← Back to site</Link>
        <div className="mt-8">
          <div className="kbd">— Admin sign in</div>
          <h1 className="mt-6 font-serif text-6xl tracking-tightest leading-none">Editorial<br/><span className="italic font-normal">access.</span></h1>
        </div>
        <form onSubmit={submit} data-testid="admin-login-form" className="mt-12 space-y-6">
          <div>
            <Label className="kbd">Email</Label>
            <Input data-testid="admin-email-input" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 h-12 rounded-none border-0 border-b border-ink/30 bg-transparent focus-visible:ring-0 focus-visible:border-ink text-lg px-0"/>
          </div>
          <div>
            <Label className="kbd">Password</Label>
            <Input data-testid="admin-password-input" required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 h-12 rounded-none border-0 border-b border-ink/30 bg-transparent focus-visible:ring-0 focus-visible:border-ink text-lg px-0"/>
          </div>
          <button data-testid="admin-login-submit" type="submit" disabled={loading} className="btn-pill-inv disabled:opacity-60">
            {loading ? "Signing in…" : "Sign in"} <ArrowUpRight size={14}/>
          </button>
        </form>
      </div>
    </div>
  );
}
